import React from "react";
import Moment from "react-moment";

function DateTimeFormat(props) {
  return <Moment format="ddd, MMM Do, YYYY">{props.children}</Moment>;
}

export default DateTimeFormat;
